define.alias("ember-composable-helpers/helpers/union", "settings/helpers/union");